"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableContext = void 0;
exports.TableContextProvider = TableContextProvider;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var paginationContext_1 = require("./paginationContext");
var createUseContext_1 = require("../helpers/createUseContext");
// import { createUseContext } from "../helpers/createUseContext";
var useLingeringFlag_1 = require("../hooks/useLingeringFlag");
var useSearchDebounce_1 = require("../hooks/useSearchDebounce");
function useTableContextData(_a) {
    var tableTitle = _a.tableTitle, _b = _a.compact, compact = _b === void 0 ? false : _b, actionButtons = _a.actionButtons, 
    // allowSorting = false,
    columns = _a.columns, _c = _a.defaultQueryParams, defaultQueryParams = _c === void 0 ? {} : _c, _d = _a.excludeSortColumns, excludeSortColumns = _d === void 0 ? [] : _d, headerColumns = _a.headerColumns, 
    // initialSortDescriptor,
    _e = _a.isFetching, 
    // initialSortDescriptor,
    isFetching = _e === void 0 ? false : _e, onPageChange = _a.onPageChange, onVisibleColumnsChanged = _a.onVisibleColumnsChanged, _f = _a.selectedKeys, selectedKeys = _f === void 0 ? [] : _f, _g = _a.selectionMode, selectionMode = _g === void 0 ? "none" : _g, setTableConfig = _a.setTableConfig, tableColumnConfig = _a.tableColumnConfig, visibleColumns = _a.visibleColumns;
    var _h = (0, useSearchDebounce_1.useSearchDebounce)(), search = _h[0], setSearch = _h[1], isSearchPending = _h[2];
    // the debounce settles a few renders before the request starts, so the flag holds through that gap instead of blinking
    var isBusy = (0, useLingeringFlag_1.useLingeringFlag)(isFetching || isSearchPending);
    var isSearchFetchArmed = (0, react_1.useRef)(false);
    // paging and filter fetches must not light the search field, so only a fetch that follows typing counts
    var isSearchBusy = (0, useLingeringFlag_1.useLingeringFlag)(isSearchPending || (isSearchFetchArmed.current && isFetching));
    (0, react_1.useEffect)(function () {
        if (!isSearchBusy)
            isSearchFetchArmed.current = false;
    }, [isSearchBusy]);
    var _j = (0, react_1.useState)(true), initialLoad = _j[0], setInitialLoad = _j[1];
    var _k = (0, react_1.useState)(defaultQueryParams), queryParams = _k[0], setQueryParams = _k[1];
    // const [sortDescriptor, setSortDescriptor] = useState<SortDescriptor>(initialSortDescriptor);
    var onQueryParamsChanged = (0, react_1.useCallback)(function (params) {
        setQueryParams(params);
    }, []);
    var onSearchChanged = (0, react_1.useCallback)(function (searchString) {
        isSearchFetchArmed.current = true;
        setSearch(searchString);
    }, []);
    // const onSortChanged = useCallback((sort: SortDescriptor) => {
    //   setSortDescriptor(sort);
    // }, []);
    // merging off the previous value rather than the captured one, so a search does not undo the page or filters set since
    (0, react_1.useEffect)(function () {
        if (search === null)
            return;
        setQueryParams(function (previous) { return (__assign(__assign({}, previous), { search_string: search })); });
    }, [search]);
    // the backend lists do not support sorting yet
    // useEffect(() => {
    //   if (allowSorting) {
    //     const order_by = sortDescriptor.direction === "ascending" ? 1 : -1;
    //     if (!!sortDescriptor) {
    //       setQueryParams({ ...queryParams, sort_by: sortDescriptor.column.toString(), order_by: order_by.toString() });
    //     } else {
    //       setQueryParams({ ...queryParams });
    //     }
    //   }
    // }, [allowSorting, sortDescriptor]);
    (0, react_1.useEffect)(function () {
        if (initialLoad) {
            return;
        }
        if (!!onPageChange) {
            if (typeof onPageChange === "function") {
                onPageChange(queryParams);
            }
        }
    }, [initialLoad, queryParams]);
    (0, react_1.useEffect)(function () {
        setInitialLoad(false);
    }, []);
    return (0, react_1.useMemo)(function () { return ({
        tableTitle: tableTitle,
        compact: compact,
        actionButtons: actionButtons,
        // allowSorting,
        columns: columns,
        excludeSortColumns: excludeSortColumns,
        headerColumns: headerColumns,
        isBusy: isBusy,
        isFetching: isFetching,
        isSearchBusy: isSearchBusy,
        onQueryParamsChanged: onQueryParamsChanged,
        onSearchChanged: onSearchChanged,
        // onSortChanged,
        onVisibleColumnsChanged: onVisibleColumnsChanged,
        queryParams: queryParams,
        search: search,
        selectedKeys: selectedKeys,
        selectionMode: selectionMode,
        setTableConfig: setTableConfig,
        // sortDescriptor,
        tableColumnConfig: tableColumnConfig,
        visibleColumns: visibleColumns,
    }); }, [
        tableTitle,
        compact,
        actionButtons,
        // allowSorting,
        columns,
        excludeSortColumns,
        headerColumns,
        isFetching,
        isBusy,
        isSearchBusy,
        onQueryParamsChanged,
        onSearchChanged,
        // onSortChanged,
        onVisibleColumnsChanged,
        queryParams,
        search,
        selectedKeys,
        selectionMode,
        setTableConfig,
        // sortDescriptor,
        tableColumnConfig,
        visibleColumns,
    ]);
}
var TableContext = (0, react_1.createContext)(null);
TableContext.displayName = "TableContext";
function TableContextProvider(props) {
    var children = props.children, drawerContent = props.drawerContent, pagination = props.pagination;
    return ((0, jsx_runtime_1.jsx)(TableContext.Provider, { value: useTableContextData(props), children: (0, jsx_runtime_1.jsx)(paginationContext_1.PaginationContextProvider, { pagination: pagination, children: children }) }));
}
var useTableContext = (0, createUseContext_1.createUseContext)(TableContext);
exports.useTableContext = useTableContext;
